export default __webpack_public_path__ + "static/media/1.e60221a5.jpg";